import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import BKUserSelect from '@/components/BKUserSelect.vue'
import { Organization, OrganizationUser, UserRole } from '@/modules/Organizations/types'
import { addUserWithRole, removeUserWithRole } from '@/enitites/organization/api/endpoints'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateOrganizationAdmins',
  props: {
    org: null
  },
  emits: ["back", "next"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'back'): void
  (e: 'next'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  org: Organization
};





const excludedUsersIds = computed(() => props.org.admins.map((admin) => admin.id))

const addAdmin = async (user: OrganizationUser, role: UserRole) => {
  const resp = await addUserWithRole(props.org.id, user.id, role)
  if (resp) props.org.admins.push(user)
}

const removeAdmin = async (user: OrganizationUser, role: UserRole) => {
  const resp = await removeUserWithRole(props.org.id, user.id, role)
  if (resp) {
    props.org.admins = props.org.admins.filter((admin) => admin.id !== user.id)
  }
}

return { __sfc: true,props, emit, excludedUsersIds, addAdmin, removeAdmin, BKUserSelect }
}

})